export default "__VITE_ASSET__Cwda4xpF__"